var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BaseModal",
    {
      attrs: { bus: _vm.busModal, "max-width": "900px", "center-screen": "" },
      scopedSlots: _vm._u([
        {
          key: "actions",
          fn: function(ref) {
            var close = ref.close
            return [
              _c("v-spacer"),
              _c(
                "BaseButton",
                { attrs: { underlined: "" }, on: { click: close } },
                [_vm._v(" Sair ")]
              ),
              _c("v-spacer")
            ]
          }
        }
      ])
    },
    [
      _c("Title", { attrs: { title: "Atualização" } }),
      _c(
        "div",
        [
          _c(
            "v-carousel",
            {
              attrs: { height: "450" },
              model: {
                value: _vm.step,
                callback: function($$v) {
                  _vm.step = $$v
                },
                expression: "step"
              }
            },
            [
              _c("v-carousel-item", [
                _c(
                  "div",
                  {
                    staticClass:
                      "d-flex align-items-center justify-content-center",
                    staticStyle: { height: "100%" }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticStyle: { width: "80%", "margin-bottom": "20vh" }
                      },
                      [
                        _c("p", [_vm._v(" Olá! ")]),
                        _c("p", [
                          _vm._v(
                            " De forma a melhorar a usabilidade e sua experiência com a plataforma, o layout da plataforma mudou! "
                          )
                        ]),
                        _c(
                          "p",
                          [
                            _vm._v(" Passe ao lado para ver os detalhes "),
                            _c("v-icon", { attrs: { color: "black" } }, [
                              _vm._v(" mdi-arrow-right ")
                            ])
                          ],
                          1
                        )
                      ]
                    )
                  ]
                )
              ]),
              _c("v-carousel-item", [
                _c(
                  "div",
                  {
                    staticClass:
                      "d-flex align-items-center justify-content-center",
                    staticStyle: { height: "100%" }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "d-flex justify-content-between",
                        staticStyle: { width: "80%", "margin-bottom": "10vh" }
                      },
                      [
                        _c(
                          "div",
                          { staticStyle: { width: "30%" } },
                          [
                            _c("v-img", {
                              attrs: {
                                src:
                                  "https://aawz-public.s3.us-east-2.amazonaws.com/images/release_notes/Imagem4.png",
                                "max-height": "300",
                                contain: ""
                              }
                            })
                          ],
                          1
                        ),
                        _c("div", { staticStyle: { width: "60%" } }, [
                          _c("p", { staticClass: "subtitle" }, [
                            _vm._v(" NAVEGAÇÃO ENTRE TELAS ")
                          ]),
                          _c("p", [
                            _vm._v(
                              " Agora você consegue navegar entre telas pela aba lateral esquerda e utilizar funções independentemente de onde você estiver no sistema, via gatilhos rápidos - imagem ao lado. "
                            )
                          ]),
                          _c("p", [
                            _vm._v(
                              " Por exemplo, consigo cadastrar um ativo, vincular uma conta de investimento, a partir de qualquer tela. Assim como atualizar a rentabilidade da sua carteira realizar um processo de portabilidade de ativos, etc. "
                            )
                          ])
                        ])
                      ]
                    )
                  ]
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _c("v-checkbox", {
        attrs: { label: "Não mostrar isso novamente" },
        model: {
          value: _vm.dontShowAgain,
          callback: function($$v) {
            _vm.dontShowAgain = $$v
          },
          expression: "dontShowAgain"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }